import {CompanyAssociation} from '../../core/model/company-associacion';

/**
 * Return information if can display company association based on company publish status and user role
 */
export const hasVisibleCompanyAssociation: (
    association: CompanyAssociation,
) => boolean = (association: CompanyAssociation) => {
    return association.company.published || association.is_opsrep;
};
